<template lang="pug">
  div
    v-card
      div.d-flex.pl-6.pr-3.align-center.justify-between.card-header
        h3 Exams
        div.d-flex.items-center.justify-end.flex-grow-1
          ExamTypesFilter(
            :loading="listLoading"
            @filterChanged="onFilterChanged"
          )
          v-btn(fab color="primary" @click="showExamModal" small)
            v-icon(small) $vuetify.icons.plus
      v-divider
      .body.no-footer.inner-scroll(style="position: relative;")
        exam-list(
          :loading="listLoading"
          :list="list"
          :pagination="pagination"
          @addItemToExam="addItemToExam"
          @removeItemFromExam="removeItemFromExam"
          @updateExam="updateExam"
          @onEditClick="editExam"
          @loadMoreClick="loadListMore"
        )
        div.loader-absolute(v-if="list && list.length && listLoading")
          v-progress-circular(indeterminate size=64 color="warning")
    add-modal(
      :value="examModalVisible"
      @input="hideExamModal"
      @closeModal="hideExamModal"
      @itemCreated="onExamCreate"
      @itemUpdated="onExamUpdate"
      @itemDeleted="onExamDelete"
      :itemModel="examModel"
      :editMode="editMode"
    )
</template>
<script>
import ExamSvc from "@/app/exercise/modules/exams/core/exam-service"
import ErrorMixin from "@/mixins/errors.mixin"
import FormErrors from "@/util/form-errors"
import {AUTO_EXAM_TYPES, NON_AUTO_EXAM_TYPES} from "../core/exam-const"
import EventBus from "@/util/event-bus"
import {LIST_EVENTS} from "@/const/list-events.enum";
import ExamTypesFilter from "@/app/exercise/modules/exams/components/ExamTypesFilter.vue";
import {FILTERS_ARGS} from "@/app/exercise/modules/trainings/core/training-const";

export default {
  components: {
    ExamTypesFilter,
    examList: () => import("./ExamList.vue"),
    addModal: () => import("./ExamModalAdd.vue"),
  },
  data: () => ({
    svc: null,
    list: [],
    listLoading: false,
    examModalVisible: false,
    examModel: null,
    editMode: false,
    editItemIndex: null,
    formErrors: null,
    pagination: null,
    NON_AUTO_EXAM_TYPES,
    AUTO_EXAM_TYPES,
    filtersQuery: {}
  }),

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.loadData()
  },

  beforeDestroy() {
    EventBus.$off(LIST_EVENTS.UPDATE_EXAM, this.updateExamKeys)
  },
  
  methods: {
    init() {
      this.svc = new ExamSvc(this.$auth)
      this.formErrors = new FormErrors()
      EventBus.$on(LIST_EVENTS.UPDATE_EXAM, this.updateExamKeys)
    },
    
    async loadData() {
      await this.loadList();
    },

    onFilterChanged(filtersObj) {
      this.filtersQuery = {...filtersObj}
      if(!filtersObj[FILTERS_ARGS.IS_AUTO]) {
        delete this.filtersQuery[FILTERS_ARGS.IS_AUTO];
      }
      if(!filtersObj[FILTERS_ARGS.IS_MOTOR]) {
        delete this.filtersQuery[FILTERS_ARGS.IS_MOTOR];
      }
      if(!filtersObj[FILTERS_ARGS.IS_SCOOTER]) {
        delete this.filtersQuery[FILTERS_ARGS.IS_SCOOTER];
      }
      this.loadList();
    },

    async loadList() {
      try {
        this.listLoading = true
        const query = {...this.filtersQuery};
        let { results, pagination } = await this.svc.list(query)
        this.pagination = pagination
        this.list = results
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }

    },

    async loadListMore(page) {
      try {
        this.listLoading = true
        let { results } = await this.svc.list({
          page,
          ...this.filtersQuery
        })
        this.list.push(...results)
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async addItemToExam(exam, item, examType, index = null) {
      const isNonAuto = exam.is_motor || exam.is_scooter;
      const examTypeFromEnum = isNonAuto ? this.NON_AUTO_EXAM_TYPES[examType] : this.AUTO_EXAM_TYPES[examType];
      if(!examTypeFromEnum) return;
      const maxLength = examTypeFromEnum.maxLength;
      if (exam[examType].length >= maxLength) {
        this.$notify({text: `Can't add more than ${maxLength} questions to this type of exam`, type: 'error'})
        return;
      }
      const licenseTypeMatch = (item.is_auto && exam.is_auto) || (exam.is_motor && item.is_motor) || (exam.is_scooter && item.is_scooter);
      if (!licenseTypeMatch) {
        this.$notify({text: 'License type mismatch', type: 'error'})
        return;
      }
      const isDuplicate = exam.addItem(item, examType, index);
      if (isDuplicate) {
        this.$notify({text: 'Duplicate item in exam', type: 'error'})
      } else {
        await this.svc.put(exam.id, exam);
        EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
      }
    },

    async removeItemFromExam(exam, item, examType) {
      exam.removeItem(item, examType);
      await this.svc.put(exam.id, exam);
      EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
    },

    async updateExam(exam) {
      await this.svc.put(exam.id, exam);
      EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
    },

    editExam(exam, index) {
      this.showExamModal();
      this.examModel = exam;
      this.editMode = true;
      this.editItemIndex = index;
    },

    hideExamModal() {
      this.examModalVisible = false;
      this.resetModalData();
    },

    resetModalData() {
      this.editMode = false;
      this.editItemIndex = null;
      this.examModel = {};
    },

    showExamModal() {
      this.examModalVisible = true
    },

    onExamCreate() {
      this.loadList();
    },

    onExamUpdate() {
      this.loadList();
    },

    onExamDelete() {
      this.list.splice(this.editItemIndex, 1)
    },
    
    updateExamKeys({exam, key}) {
      this.list.forEach( item => {
        if( item.id === exam.id ) {
          item[key] = exam[key];
        }
      } );
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-absolute {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.5);
  z-index: 18;
  top: 0;
  left: 0;
}
</style>